import { Transition } from "@headlessui/react";
import React from "react";
import { useParams } from "react-router-dom";
import Error from "../../common/components/error";
import Loading from "../../common/components/loading";
import { useLenderQuery } from "../../graphql/generated";
import LenderSummary from "../components/summary";
import LenderTitle from "../components/title";
import { useTitle } from "../../common/utils/title";

const LenderShow: React.FC = () => {
  const params = useParams();
  const [{ data, error }] = useLenderQuery({
    variables: { id: params.lenderId ?? "" },
    pause: !params.lenderId,
  });
  useTitle((data?.lender.name || "") ?? params.lenderId, "Lenders");

  return (
    <>
      <Loading show={!data && !error} />
      <Error error={error} />
      <Transition
        show={!!data}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
      >
        <div className="max-w-7xl mx-auto py-4">
          <LenderTitle lender={data?.lender} />
          <LenderSummary lender={data?.lender} />
        </div>
      </Transition>
    </>
  );
};

export default LenderShow;
